import "@arco-design/web-react/es/Layout/style";
import _Layout from "@arco-design/web-react/es/Layout";
import "@arco-design/web-react/es/Grid/style";
import _Grid from "@arco-design/web-react/es/Grid";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import cs from 'classnames';
import styles from './style/index.module.less';

function Footer(props = {}) {
  const {
    className,
    ...restProps
  } = props;
  return /*#__PURE__*/React.createElement(_Layout.Footer, _extends({
    className: cs(styles.footer, className)
  }, restProps), /*#__PURE__*/React.createElement("div", {
    className: styles.footer_row
  }, /*#__PURE__*/React.createElement(_Grid.Row, {
    gutter: 16,
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(_Grid.Col, {
    xs: 24,
    sm: 24,
    md: 12,
    className: styles.footer__panel
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.footer__title
  }, "Contact"), /*#__PURE__*/React.createElement("div", {
    className: styles.footer__content
  }, /*#__PURE__*/React.createElement("a", {
    href: "mailto:customerservice@clearmdhealth.com"
  }, "customerservice@clearmdhealth.com"), " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    href: "tel:1 (844) MDCLEAR"
  }, "1 (844) MDCLEAR"))), /*#__PURE__*/React.createElement(_Grid.Col, {
    xs: 24,
    sm: 24,
    md: 12,
    className: styles.footer__panel
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.footer__title
  }, "Billing (only)"), /*#__PURE__*/React.createElement("div", {
    className: styles.footer__content
  }, /*#__PURE__*/React.createElement("a", {
    href: "mailto:billing@clearmdhealth.com"
  }, "billing@clearmdhealth.com"), " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    href: "tel:1 (646) 249 9333"
  }, "1 (646) 249 9333"))), /*#__PURE__*/React.createElement(_Grid.Col, {
    xs: 24,
    sm: 24,
    md: 12,
    className: styles.footer__panel
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.footer__title
  }, "Media"), /*#__PURE__*/React.createElement("div", {
    className: styles.footer__content
  }, /*#__PURE__*/React.createElement("a", {
    href: "mailto:bernie@clearmdhealth.com"
  }, "bernie@clearmdhealth.com"), " ", /*#__PURE__*/React.createElement("br", null))), /*#__PURE__*/React.createElement(_Grid.Col, {
    xs: 24,
    sm: 24,
    md: 12,
    className: styles.footer__panel
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.footer__title
  }, "Group/Event testing"), /*#__PURE__*/React.createElement("div", {
    className: styles.footer__content
  }, /*#__PURE__*/React.createElement("a", {
    href: "mailto:business@clearmdhealth.com"
  }, "business@clearmdhealth.com"), " ", /*#__PURE__*/React.createElement("br", null))), /*#__PURE__*/React.createElement(_Grid.Col, {
    xs: 24,
    sm: 24,
    md: 12,
    className: styles.footer__panel
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.footer__title
  }, "Headquarters"), /*#__PURE__*/React.createElement("div", {
    className: styles.footer__content
  }, "32 6th Avenue ", /*#__PURE__*/React.createElement("br", null), "New York, NY 10013")), /*#__PURE__*/React.createElement(_Grid.Col, {
    xs: 24,
    sm: 24,
    md: 12,
    className: styles.footer__panel
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.footer__title
  }, "Hours"), /*#__PURE__*/React.createElement("div", {
    className: styles.footer__content
  }, "7 days a week ", /*#__PURE__*/React.createElement("br", null), "8am - 7pm")))));
}

export default Footer;